import { render, staticRenderFns } from "./VTags.vue?vue&type=template&id=9ac7e77c&"
import script from "./VTags.vue?vue&type=script&lang=js&"
export * from "./VTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports